import React from 'react';
import { Select } from 'antd';
import { withNamespaces } from 'react-i18next';
import FormBuilderCustomView from "../../containers/FormBuilder/FormBuilderCustomView";
import get from "lodash/get";
import {getBackendConsentType} from "../../utils/consentUtils";
import PatientElectronicText from "./Texts/PatientElectronicText";

const { Option } = Select;

class ConsentStep3aRegainedCapacity extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

        // by_person_settings.patient.consent_types.consent_patient_form.electronic.form
    // by_person_settings.patient.consent_types.consent_patient_form.electronic.form
    const backEndType = getBackendConsentType(props.consentPersonType, props.consentMethodType);
    let methodType = 'electronic';
    if (props.consentMethodType.toLowerCase().includes('email')){
      methodType = 'email';
    }
    if (props.consentMethodType.toLowerCase().includes('paper')){
      methodType = 'paper';
    }

    const formSchema = this.props.ui_form || get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.${methodType}.form`);
    const content = this.props.ui_content || get(this.props.by_person_settings, `${props.consentPersonType.toLowerCase()}.consent_types.${backEndType}.${methodType}.content`);


    // TODO error out gracefully if formSchema and content are empty, just dont show anything without breaking

    const initial_form_data = get(this.props, 'initial_form_data', undefined);


    const isEmail = props.consentMethodType && props.consentMethodType.includes("Email");
    const isAfterDeferral = props.consentMethodType.includes('AfterDeferral');
    const isSurrogate = props.consentPersonType === "Surrogate";
    const showForEmail = !(isEmail && !props.token);
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";

    let preNameOfParticipant = '';
    let NameOfParticipant = props.i18n.t('NamespaceConsent:Name of Participant');
    let SignatureOfParticipant = props.i18n.t('NamespaceConsent:Signature of Participant');
    let NameofPersonObtainingConsent = props.i18n.t('NamespaceConsent:Name of Person Obtaining Consent');
    let SignatureOfPersonObtainingConsent = props.i18n.t('NamespaceConsent:Signature of Person Obtaining Consent');


    return (
      <div className="form-group consent-form-ui">
        <style>
          {".consent-form-ui h1, h2, h3, h4, h5, h6 {text-transform: none;}"}
        </style>
        <div className="form-group-details">
          <h4>{this.props.i18n.t('NamespaceConsent:Consent Process - PATIENT ASSENT')}</h4>

          {props.siteID && <h5>{this.props.i18n.t('NamespaceConsent:Site ID')}: <b>{props.siteID}</b></h5>}
          {props.userID && <h5>{this.props.i18n.t('NamespaceConsent:User ID')}: <b>{props.userID}</b></h5>}
          <h5>{this.props.i18n.t('NamespaceConsent:Subject ID')}: <b>{props.subjectID}</b></h5>
        </div>

        <PatientElectronicText content={content} />

        <p><strong>{this.props.i18n.t('NamespaceConsent:Server Date (UTC)')}: {props.consentDate || props.date}</strong></p>
        <p><strong>{this.props.i18n.t('NamespaceConsent:Consent Type')}: {props.consentPersonType}</strong></p>
        <p><strong>{this.props.i18n.t('NamespaceConsent:Consent Method')}: {props.consentMethodType}</strong></p>
        <p>&nbsp;</p>

        <div style={{ textAlign: "left" }}>
          <FormBuilderCustomView
            initialValues={initial_form_data}
            saveButton={this.props.i18n.t('NamespaceConsent:Next')}
            backStep={this.props.backStep}
            isEditable={true}
            schema={formSchema}
            name={''}
            onSubmit={this.props.handleSubmitBuildForm}
          />
        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentStep3aRegainedCapacity)



// WEBPACK FOOTER //
// ./src/components/ConsentTypeHope_ii_V2_1/ConsentStep3aRegainedCapacity.js